import React from 'react'
import PropTypes from 'prop-types'

const Select = ({ object, name, onChange, valueList = [], renderer, style = {}, addEmpty = false, type, readOnly = false, defaultValue = '', id = '' }) => {
    let selectedValue = object[name]
    if (typeof selectedValue === 'boolean') {
        selectedValue = String(object[name])
    }
    selectedValue = String(selectedValue || defaultValue)

    return (<select
        id={id}
        className="form-control"
        style={style}
        disabled={readOnly}
        value={selectedValue}
        onChange={(event) => {
            if (readOnly) {
                return
            }
            let value = event.target.value
            if (type === 'int') {
                value = parseInt(value, 10)
            }
            onChange(name, value)
        }}>
        {addEmpty && <option key="empty" value=""/>}
        {valueList.map(object => {
            const displayText = renderer ? renderer(object) : object.value
            return <option key={object.id} value={object.id} disabled={object.disabled}>{displayText}</option>
        })}
    </select>)
}

Select.propTypes = {
    object: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    style: PropTypes.any,
    type: PropTypes.string,
    onChange: PropTypes.func,
    renderer: PropTypes.func,
    validation: PropTypes.object,
    className: PropTypes.string,
    valueList: PropTypes.array,
    addEmpty: PropTypes.bool,
    readOnly: PropTypes.bool,
    defaultValue: PropTypes.string,
    id: PropTypes.string,
}


export default Select



// WEBPACK FOOTER //
// ./src/modules/form/component/Select.js